import React, { useState } from "react";
import { addChange, addchange } from "./Utilities/api";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/userSlice";
import { useNavigate } from "react-router-dom";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { PageHeader, PageShell } from "../../components/UI/Page";

const Changes = () => {
  const [change, setChange] = useState("");
  const user = useSelector(selectUser);
  const navigate = useNavigate();

  const handleChange = (event) => {
    setChange(event.target.value);
  };

  const handleSubmit = () => {
    const data = {
      change: change,
      submittedBy: user,
      date: new Date(),
    };
    addChange(data);
    setChange("");
  };

  return (
    <PageShell size="sm">
      <PageHeader
        icon={EditNoteIcon}
        tone="slate"
        eyebrow="Admin"
        title="Node Changes"
        description="Input Node changes here."
      />

      <div className="app-card rounded-2xl border p-5">
        <label htmlFor="node-change" className="mb-1.5 block text-sm font-semibold">
          Change
        </label>
        <textarea
          id="node-change"
          className="app-input block w-full rounded-xl border px-3 py-2 text-sm"
          rows="5"
          value={change}
          onChange={handleChange}
          placeholder="Enter your changes here..."
        ></textarea>

        <div className="mt-4 flex justify-end">
          <button
            type="button"
            className="app-btn app-btn-primary"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </PageShell>
  );
};

export default Changes;
